import styles from './iosToggle.module.scss';

export const IosToggle = ({state, onChangeAction, disabled}) => {
    return <label className={`${styles.switch} ${disabled ? styles.disabled : ''}`}>
        <input type="checkbox" id="iosToggle" checked={state} disabled={disabled} onChange={(e)=>{
            if(onChangeAction)onChangeAction(e.target.checked);
        }} />
        <span className={styles.slider}></span>
    </label>
}